import React from 'react';
import { useSelector } from 'react-redux';
import {Backdrop, CircularProgress} from '@mui/material';

export default function BackDrop(props) {

  const loaderStatus = useSelector((state) => state.commonReducer.showLoader);

    return (
      <Backdrop
      className='backDropColor'
      open={props?.type || loaderStatus || false}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
    );
}